// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ThemeToggleController from "./theme_toggle_controller"
application.register("theme-toggle", ThemeToggleController)

import ModalTriggerController from "./modal_trigger_controller"
application.register("modal-trigger", ModalTriggerController)

import StatChartController from "./stat_chart_controller"
application.register("stat-chart", StatChartController)
